import cn from '@/utils/cn';
import { Dialog, Modal } from 'react-aria-components';
import React from 'react';
import Icon from '@/components/ui/Icon';
import I18n from 'i18n-js';
import CommentCard from './CommentCard';
import styles from './CommentDrawer.module.scss';
import { TeacherCommentType } from '../../hooks/useQuestionAnswers';

type CommentDrawerProps = {
  assignmentId: number;
  comments: TeacherCommentType[];
  drawerOpen: boolean;
  setDrawerOpen: (state: boolean) => void;
  score?: string | null;
};

const CommentDrawer = ({ assignmentId, comments, drawerOpen, score, setDrawerOpen } : CommentDrawerProps) => (
  <Modal
    isDismissable
    aria-label="teacher-comments"
    className={cn(styles.drawer, 'tw-transition-all tw-text-base')}
    isOpen={drawerOpen}
    onOpenChange={setDrawerOpen}
  >
    <Dialog className={cn('tw-h-screen tw-flex tw-flex-col tw-p-8 tw-shadow-[-4px_0px_8px_0px_rgba(0,0,0,0.20)]',
      'tw-border-l-2 tw-border-med-grey tw-border-solid tw-overflow-y-auto')}
    >
      <div className="tw-w-full tw-flex tw-justify-end">
        <button
          className="btn close tw-shadow-none tw-p-none tw-w-5 tw-h-5"
          type="button"
          onClick={() => setDrawerOpen(false)}
        >
          <Icon icon="Close" size={16} />
        </button>
      </div>
      <h2 className="tw-w-full tw-pb-4 tw-pt-8 tw-mb-6 tw-border-b tw-border-solid tw-border-light-grey">
        {I18n.t('assignment_details')}
      </h2>
      {score && (
        <div className="tw-w-full tw-mb-4 tw-flex tw-justify-between tw-items-center tw-font-bold">
          <p>{I18n.t('grade')}</p>
          <p>{score}</p>
        </div>
      )}
      <p className="tw-font-bold"> Comments </p>
      {comments && comments.map(comment => (
        <CommentCard
          key={comment.id}
          assignmentId={assignmentId}
          comment={comment}
        />
      ))}
    </Dialog>
  </Modal>
);

export default CommentDrawer;
